import { UserManager as OriginalUserManager, User, WebStorageStateStore } from 'oidc-client';
import jwtDecode from 'jwt-decode';

const authority = config.VUE_APP_OIDC_AUTHORITY || process.env.VUE_APP_OIDC_AUTHORITY;
const clientId = config.VUE_APP_OIDC_CLIENT_ID || process.env.VUE_APP_OIDC_CLIENT_ID;

const userStore = new WebStorageStateStore({
  store: window.localStorage
});

export class UserManager extends OriginalUserManager {
  // The original getUser() function returns a promise but it's actually a sync operation.
  public getUserSync(): User | null {
    // @ts-ignore: technical debt, accesses a private member of oidc lib
    const storageString = this._userStore._store.getItem(userStore._prefix + this._userStoreKey);
    return storageString ? User.fromStorageString(storageString) : null;
  }

  public setUserLocale(locale: string) {
    const user = this.getUserSync();
    if (user) {
      user.profile.locale = locale;
      const userStr = user.toStorageString();
      // @ts-ignore: technical debt, accesses a private member of oidc lib
      this._userStore._store.setItem(userStore._prefix + this._userStoreKey, userStr);
    }
  }

  public getApiKey(): string {
    const user = this.getUserSync();
    return user ? `Bearer ${user.id_token}` : '';
  }

  public decodeToken(): any {
    const user = this.getUserSync();
    return user ? jwtDecode(user.id_token) : null;
  }

  public getIdToken(): string {
    const user = this.getUserSync();
    return user ? `${user.id_token}` : '';
  }

  public async logout(): Promise<void> {
    const state = await this.createSigninRequest().then(req => req.state);
    // Adding these special query params to the sign-out URL will redirect to the login prompt.
    return this.signoutRedirect({
      extraQueryParams: {
        client_id: state._client_id,
        redirect_uri: state._redirect_uri,
        scope: state._scope,
        state: state._id,
        response_type: 'code'
      }
    }).then(() => sessionStorage.clear());
  }
}

const userManager = new UserManager({
  authority,
  client_id: clientId,
  redirect_uri: `${window.location.origin}/callback`,
  silent_redirect_uri: `${window.location.origin}/callback`,
  response_type: 'code',
  scope: 'openid email profile',
  loadUserInfo: true,
  automaticSilentRenew: true,
  userStore
});

// Override end_session_endpoint
userManager.metadataService.getEndSessionEndpoint = () => userManager.metadataService
  .getAuthorizationEndpoint()
  .then(url => url.replace('oauth2/authorize', 'logout'));

export default userManager;
